
export { AuthService as AuthServiceV2 } from '../appv2/core/services/authentication/auth.service';